import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Variable } from '@core/models/variable.model';

@Component({
  selector: 'app-certificate-block',
  templateUrl: './certificate-block.component.html',
  styleUrls: ['./certificate-block.component.css'],
})
export class CertificateBlockComponent {
  @Input() variables: Variable[] = [];
  @Input() form!: FormGroup;
}
